import closest from 'closest';
import { throttle } from 'lodash';
import $ from "jquery";

const focusableElementsSelector =
    'button, [href], input:not([type="radio"]), select, textarea, [tabindex]:not([tabindex="-1"]), input[type="radio"]:checked';

function getMenuItems(element) {
    return Array.from(element.querySelectorAll('[data-role="menuitem"]'));
}

export default class Megamenu {
    expandMenu(menuItem, focusMode = 'first') {
        this.menuExpanded = true;
        if (!menuItem.hasAttribute('aria-expanded'))
            return;
        menuItem.setAttribute('aria-expanded', 'true');
        let closeItem = $(menuItem).children('.vgr-megamenu__closed');
        let openItem = $(menuItem).children('.vgr-megamenu__opened');

        this.showIcon(closeItem);
        this.hideIcon(openItem);

        let wrapper = document.firstElementChild;
        let displayMode = this.getDisplayMode();
        if (displayMode === "mobile")
            wrapper.style.overflow = "hidden";

        let Homeicon = this.element.querySelector('.vgr-megamenu__departments-home');


        // Vid klick på ändra förvaltning , ta bort hem ikonen.
        if (menuItem.classList.contains('vgr-megamenu__departments-change'))
            Homeicon.style.display = 'none';

        let menuContent;
        let ownedElementId;
        if ((ownedElementId = menuItem.getAttribute('aria-owns'))) {
            menuContent = this.element.querySelector("#" + ownedElementId);
            menuContent.setAttribute('aria-hidden', 'false');
        }
        else {
            menuContent = menuItem.nextElementSibling;
        }
        if (menuContent !== undefined && menuContent !== null) {
            this.attachSubMenuEvents(menuContent);
            let focusElement =
                (focusMode === 'auto' &&
                    menuContent.querySelector('[data-autofocus="true"]')) ||
                (focusMode === 'first' &&
                    menuContent.querySelector(focusableElementsSelector)) ||
                getMenuItems(menuContent).slice(focusMode === 'last' ? -1 : 0)[0];
            if (focusElement) {
                focusElement.focus();
            }
        }
    };
    collapseMenu(focus, currentItem) {
        this.menuExpanded = false;

        if (currentItem === undefined || currentItem === null) {
            currentItem = this.element.querySelector(
                '[data-role="menuitem"][aria-expanded="true"]',
            );
        }

        if (!currentItem) {
            return;
        }
        currentItem.setAttribute('aria-expanded', 'false');
        let ownedElementId;
        if ((ownedElementId = currentItem.getAttribute('aria-owns'))) {
            let menuContent;
            menuContent = this.element.querySelector("#" + ownedElementId);
            menuContent.setAttribute('aria-hidden', 'true');
        }
        if (focus) {
            currentItem.focus();
        }
        let closeItem = $(currentItem).children('.vgr-megamenu__closed');
        let openItem = $(currentItem).children('.vgr-megamenu__opened');
        this.hideIcon(closeItem);
        this.showIcon(openItem);

        let wrapper = document.firstElementChild;
        let displayMode = this.getDisplayMode();
        let menu = document.getElementById("megamenu-global");
        if (menu.getAttribute('aria-expanded') === 'false' && displayMode === "mobile")
            wrapper.style.overflow = "scroll";
    };
    getDisplayMode = () => {
        return this.element.getAttribute('data-display-mode');
    };
    updateDisplayMode = () => {
        let displayMode = this.getDisplayMode();
        let rackWidth = this.element.offsetWidth;

        if (displayMode === 'desktop') {
            let rackContentWidth = this.element.querySelector('.vgr-megamenu__rack')
                .scrollWidth;
            if (rackContentWidth > rackWidth) {
                this.desktopMinWidth = rackContentWidth;
            }
        }

        let previousDisplayMode = displayMode;
        displayMode = rackWidth >= this.desktopMinWidth ? 'desktop' : 'mobile';

        var nav = this.element;

        // Updatera aria-hidden attributet och office365 banner class varje gång display-mode ändras.
        if (previousDisplayMode !== displayMode && displayMode === 'mobile') {
            var menuItems = this.element.querySelector(".vgr-megamenu__menu-items");
            var topPersonalization = document.querySelector(".top-personalization");

            // Dölj dolda menyalternativ för skärmläsare.
            if ($(menuItems).attr('aria-hidden') === "false") {
                menuItems.setAttribute("aria-hidden", "true");
            }

            // Dölj office 365 banner.
            if (!(topPersonalization.classList.contains('vgr-hidden'))) {
                topPersonalization.classList.add('vgr-hidden');
            }
        }

        // Uppdatera positionering på megameny. 
        if (nav.style.position === 'fixed') {
            nav.style.position = "relative";
        }

        // let menuPosition = 'top';
        // window.innerHeight < 800 &&
        // window.innerHeight > window.innerWidth &&
        // displayMode === 'mobile'
        //   ? 'bottom'
        //   : 'top';
        this.element.setAttribute(
            'data-display-mode',
            displayMode,
            // `${displayMode} ${menuPosition}`,
        );
        // Remove open menu items when switching display modes
        let displayModeChanged = this.previousDisplayMode !== null && this.previousDisplayMode !== displayMode;
        if (displayModeChanged) {
            Array.from(
                this.element.querySelectorAll(
                    '.vgr-megamenu__link[aria-expanded=true]',
                ),
            ).forEach(element => {
                element.setAttribute('aria-expanded', 'false');
            });
            if (this.previousDisplayMode === 'mobile') {
                let openMenuButton = this.element.querySelector(
                    '.vgr-megamenu__button[aria-expanded=true]',
                );
                if (openMenuButton) {
                    this.collapseMenu();
                }
            }
        }
        this.previousDisplayMode = displayMode;
    };
    // Return a promise which resolves after the specified interval
    delay = (interval) => {
        return new Promise(function (resolve) {
            setTimeout(resolve, interval);
        });
    };
    expandStartOpenItems = () => {
        Array.from(
            this.element.querySelectorAll(
                '.vgr-megamenu__link[data-startopen=true]',
            ),
        ).forEach(element => {
            element.setAttribute('aria-expanded', 'true');
        });
    };
    hideIcon = (items) => {
        Array.prototype.forEach.call(items, item => {
            if (!item.classList.contains('vgr-hidden')) {
                item.classList.add('vgr-hidden');

            }
        });
    };
    showIcon = (items) => {
        Array.prototype.forEach.call(items, item => {
            if (item.classList.contains('vgr-hidden')) {
                item.classList.remove('vgr-hidden');
            }
        });
    };
    handleKeyDownDesktop(event) {
        let element = this.element;
        switch (event.key) {
          case "Enter":
          case "Spacebar":
          case " ":
            {
              if (event.target.getAttribute("aria-expanded") === "true") {
                event.preventDefault();
                this.expandMenu(event.target);
              }
            }
            break;
          case "Escape":
          case "Esc":
            {
              if (this.menuExpanded) {
                // Close submenu and focus on the menubar item when pressing escape from inside a submenu
                event.preventDefault();
                this.collapseMenu(true);
              }
            }
            break;
          case "Tab":
            {
              if (event.target.getAttribute("data-index") === "last")
                this.collapseMenu(true);
            }
            break;
        }
    };
    handleKeyDownMobile(event) {
        switch (event.key) {
          case "Escape":
          case "Esc":
            {
              if (this.menuExpanded) {
                event.preventDefault();
                this.collapseMenu(true);
              }
            }
            break;
        }
    }
    attachSubMenuEvents(menuItems) {
        const hiddenButtons = menuItems.querySelectorAll('button.has-children, a.vgr-megamenu-level2__item-link');
        hiddenButtons.forEach((button, index) => {
            if(this.getDisplayMode() === "mobile")
                button.tabIndex = -1;

            if(hiddenButtons.length - 1 === index)
                button.setAttribute('data-index', 'last')

            button.addEventListener("click", function(event) {
                const focusElements = event.currentTarget.parentNode.querySelectorAll('.vgr-megamenu-level2__item a');
                focusElements.forEach(focusElement => {
                    focusElement.tabIndex = 1;
                })
                focusElements[0].focus();
            });
        });
    }
     constructor(element) {
        this.element = element;
        this.desktopMinWidth = 0;
        this.previousDisplayMode = null;
        var self = this;

        // Set a timeout for 0 seconds
        this.delay(0).then(function () {
            self.updateDisplayMode();
        })
            // After the display mode has been updated
            .then(function () {
                if (self.getDisplayMode() === 'mobile') {
                    // Expand the items that should start open for the mobile menu
                    self.expandStartOpenItems();
                }
            });

        window.addEventListener('resize', throttle(this.updateDisplayMode, 200));
        document.addEventListener('click', event => {
            if (!this.element.contains(event.target)) {
                this.collapseMenu();
            }
        });
        Array.from(
            element.querySelectorAll('.vgr-megamenu-level2[data-edit]'),
        ).forEach(list => {
            list
                .querySelector('[data-action="toggle-edit"]')
                .addEventListener('click', event => {
                    let edit = list.getAttribute('data-edit') !== 'true';
                    list.setAttribute('data-edit', String(edit));
                    event.target.setAttribute('aria-pressed', String(edit));
                    Array.from(
                        list.querySelectorAll('.vgr-megamenu-level2__link'),
                    ).forEach(link => {
                        link.setAttribute('tabindex', edit ? '-1' : '0');
                    });
                });
        });
        Array.from(
            element.querySelectorAll(
                '.vgr-megamenu-level2[data-edit] .vgr-megamenu-level2__item',
            ),
        ).forEach(item => {
            item
                .querySelector('.vgr-megamenu-level2__remove-button')
                .addEventListener('click', event => {
                    event.stopPropagation();
                    item.parentNode.removeChild(item);
                });
        });
        element
            .querySelector('.vgr-megamenu__rack')
            .addEventListener('click', event => {
                event.stopPropagation();

                let Homeicon = element.querySelector('.vgr-megamenu__departments-home');
                let menu = element.querySelector('.vgr-megamenu__menu');
                if (event.target.hasAttribute('aria-expanded')) {
                    event.preventDefault();

                    // vid klick på ändra förvaltning                   
                    if (event.target.getAttribute('aria-expanded') === 'false' && event.target.classList.contains('vgr-megamenu__departments-change') && this.getDisplayMode() !== 'desktop') {
                        this.expandMenu(event.target);
                        menu.setAttribute("style", "display:none");

                    }
                    else if (event.target.getAttribute('aria-expanded') === 'false' && !event.target.classList.contains('vgr-megamenu__departments-change')) {
                        // Stäng det senast öppnade meny alternativet?
                        if (this.getDisplayMode() === 'desktop') {
                            this.collapseMenu();
                        }
                        // Öppna det valda menyalternativet
                        this.expandMenu(event.target, 'auto');
                    }

                    else {
                        if (this.getDisplayMode() === 'desktop') {
                            this.collapseMenu();
                        } else {
                            menu.setAttribute("style", "display:block");

                            Homeicon.style.display = 'flex';
                            this.collapseMenu(false, event.target);

                        }
                    }
                }
            });
        element
            .querySelector('#megamenu-global')
            .addEventListener('click', event => {
                event.stopPropagation();

                // If the main menu is clicked, then the search menu should be closed
                var searchMenu = element.querySelector('#megamenu-search');
                var rack = element.querySelector('.vgr-megamenu__rack');
                let nav = element;

                if (searchMenu.getAttribute('aria-expanded') === 'true') {
                    this.collapseMenu();
                }
                if (event.target.hasAttribute('aria-expanded')) {
                    event.preventDefault();
                    if (event.target.getAttribute('aria-expanded') === 'false') {
                        event.target.setAttribute('aria-expanded', 'true');
                        this.expandMenu(event.target, 'auto');

                        if (this.getDisplayMode() !== 'desktop')
                            // När mobilmenyn är öppen så behöver hamburgarmenyn sättas fast på toppen av skärmen
                            nav.style.position = "fixed";

                        rack.style.position = "fixed";


                    } else {
                        this.collapseMenu();
                        event.target.setAttribute('aria-expanded', 'false');

                        if (this.getDisplayMode() !== 'desktop')

                            // När mobilmenyn är inte öppen så behöver hamburgarmenyn inte vara fast på toppen av skärmen
                            nav.style.position = "relative";

                        rack.style.position = "relative";


                    }
                }
            });
        element
            .querySelector('#megamenu-search')
            .addEventListener('click', event => {
                event.stopPropagation();

                // If the search menu is clicked, then the main menu should be closed
                var globalMenu = element.querySelector('#megamenu-global');
                let nav = element;
                var rack = nav.querySelector('.vgr-megamenu__rack');
                if (globalMenu.getAttribute('aria-expanded') === 'true') {
                    this.collapseMenu();
                }
                if (event.target.hasAttribute('aria-expanded')) {
                    event.preventDefault();
                    if (event.target.getAttribute('aria-expanded') === 'false') {
                        this.expandMenu(event.target, 'auto');

                        nav.style.position = "fixed";
                        rack.style.position = "fixed";

                    } else {
                        this.collapseMenu();
                        nav.style.position = "relative";
                        rack.style.position = "relative";


                    }
                }
            });
        element.addEventListener('keydown', event => {
            switch (this.getDisplayMode()) {
                case 'desktop':
                    {
                        this.handleKeyDownDesktop(event);
                    }
                    break;
                 case 'mobile':
                   {
                     this.handleKeyDownMobile(event);
                   }
                   break;
            }
        });
    }
}
